import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConsultaSojService {

  constructor(private _http: HttpClient) {}

  getListBy(value_type: string, value: string) {
    return this._http.get<any>(`${environment.BACKEND}report/soj-list/${value_type}/${value}`);
  }

  AdelantarTransferencia(value): Observable<any>  {
    return this._http.post<any>(`${environment.BACKEND}transferDate/adelantar`, value);
  }
}
